/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TCPropertyImportAssignmentMode {
    KEEP = 'keep',
    FORCE_USER = 'forceUser',
    AUTO = 'auto',
}
